import React, { useState, useEffect, Fragment } from 'react';

import SatTab from '@components/common/satUI/SatTab';
import SatButton from '@components/common/satUI/SatButton';
//TODO KB
import * as kbValidation from '@common/utils/kbValidation';
import SatInput from '@components/common/satUI/SatInput';
import { useSelector } from 'react-redux';
import { checkSameProductCode } from '@common/utils';
import { PRODUCT_COMP_CD } from '@common/constants';
import { SUB_PRD_CODE_SALES_STOP } from '@common/utils';

/**
 * 주계약 상품 (KB/PRU 아이콘 + 상품명 + 선택/확인 버튼)
 * @param {object} props
 * @param {object} props.product 상품 정보
 * @param {object} props.selectedProduct 선택한 상품 정보
 * @param {boolean} props.selectedProduct.childToggle 자식 상품 토글 여부 (true: 자식 상품 선택창 표시)
 * @param {string} props.selectedProduct.code 선택한 상품 코드
 * @param {function} props.setSelectedProduct 주계약 상품 선택 함수
 * @param {string} props.selectedChild 선택한 자식 상품 코드
 * @param {function} props.setSelectedChild 주계약 - 자식 상품 선택 함수
 * @param {function} props.onSelectProduct 주계약 상품 선택 이벤트 핸들러
 * @param {function} props.onSelectChildProduct 주계약 - 자식 상품 선택 이벤트 핸들러
 * @param {function} props.showModal 모달 팝업 호출
 * @returns {JSX.Element}
 * @constructor
 */
const Product = props => {
  const {
    product,
    selectedProduct,
    setSelectedProduct,
    selectedChild,
    setSelectedChild,
    onSelectProduct,
    onSelectChildProduct,
    showModal,
  } = props;

  // useState 등 기타 hooks
  const [isActive, setIsActive] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [styleClass, setStyleClass] = useState('');
  const [productName, setProductName] = useState('');

  // effect hooks
  /**
   * 상품명, 활성화/비활성화 상태 설정
   */
  useEffect(() => {
    if (product.child && selectedChild !== '') {
      const childProduct = product.child.find(item =>
        checkSameProductCode(item.productCode, selectedChild),
      );
      setProductName(childProduct?.productName || product.productName);
    } else {
      setProductName(() => product.productName);
    }
    setIsActive(
      checkSameProductCode(product.productCode, selectedProduct.code),
    );
    setIsDisabled(product.disabled);
  }, [product, selectedProduct, selectedChild]);

  /**
   * 활성화, 비활성화 상태 여부에 따라
   * 스타일 클래스 변경 처리
   */
  useEffect(() => {
    let className = 'utilItem ';
    //일단 상품 명을 모르기에 일단 설정
    //if (where.includes('kb')) {
    //TODO : 상품 서비스 합쳐지기 전 임시로 KB상품 셋팅,, 상품이 합쳐져 있어서 처리함
    //K면 kb, p면 pru
    //TODO selectProduct.compCd 상품에 따라 변경 예정 1 : 공통, 2 : KB, 3 : Pru 2022.09.20
    if (product.compCd === PRODUCT_COMP_CD.kb) {
      className += 'kb ';
    } else {
      className += 'pok ';
    }

    if (isActive) className += 'active ';
    if (isDisabled) className += 'disabled ';

    setStyleClass(className);
  }, [isActive, isDisabled, styleClass]);

  // event handler
  /**
   * 주계약 상품 선택 이벤트 핸들러
   */
  const handleSelectProduct = () => {
    if (product.disabled) {
      showModal({ visible: true, msg: product.disabledMsg });
      return;
    }

    onSelectProduct(product, product.child);
  };

  /**
   * 주계약 - 자식 선택 이벤트 핸들러
   * @param {object} productInfo 자식 상품 정보
   */
  const handleSelectChild = productInfo => {
    const productCode = productInfo?.productCode;
    setSelectedChild(productCode);
    setSelectedProduct({
      ...selectedProduct,
      childToggle: !selectedProduct.childToggle,
    });
  };

  /**
   * 자식 상품 선택 컴포넌트
   * @param props
   * @returns {JSX.Element}
   * @constructor
   */
  const ChildProduct = props => {
    const {
      childProducts,
      productName,
      styleClass,
      childToggle,
      onSelectProduct,
      onSelectChild,
    } = props;

    return (
      <div
        className={`more-list ${
          styleClass.includes('disabled') ? 'disabled' : ''
        }`}
      >
        {productName}
        <div className="tooltip-wrap">
          <SatButton
            styleClass={`btn-tooltip active ${
              styleClass.includes('disabled') ? 'disabled' : ''
            }`}
            label={'선택 +'}
            onClick={onSelectProduct}
            isNoSpan={true}
          />
          {styleClass.includes('active') && childToggle && (
            <div className="tooltip-box">
              <ul className="insu-pro-list">
                {childProducts.map((childProd, index) => {
                  return (
                    <li
                      key={index}
                      className={`${
                        checkSameProductCode(
                          childProd.productCode,
                          selectedChild,
                        ) && 'active'
                      }`}
                      onClick={() => onSelectChild(childProd)}
                    >
                      <a>{childProd.productName}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <li
      className={styleClass}
      onClick={() => !product.child && handleSelectProduct()}
    >
      {/* [Robin]: 회사[KB/Pru] 아이콘 제거  */}
      {/* <div className="icon_box pdl-30">
        <span
          className={`ico2 ico-${
            product.compCd === PRODUCT_COMP_CD.pr
              ? 'p'
              : PRODUCT_COMP_CD.kb
              ? 'k'
              : 'a'
          }`}
        >
          통합
        </span>
      </div> */}
      {product.child ? (
        <ChildProduct
          childProducts={product.child}
          productName={productName}
          styleClass={styleClass}
          childToggle={selectedProduct.childToggle}
          onSelectProduct={handleSelectProduct}
          onSelectChild={handleSelectChild}
        />
      ) : (
        <span>{productName}</span>
      )}

      {checkSameProductCode(product.productCode, selectedProduct.code) && (
        <SatButton
          styleClass="btn-s blue side-r"
          label={'확인'}
          onClick={() => onSelectChildProduct(product)}
          isNoSpan={true} //button -> span 없음 처리
        />
      )}
    </li>
  );
};

/**
 * 주계약 상품 타입별 리스트(예 : 종신, 연금/저축 등)
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProductList = props => {
  const {
    list,
    type,
    selectedProduct,
    setSelectedProduct,
    selectedChild,
    setSelectedChild,
    onSelectMainContract,
    showModal,
    compCd,
  } = props;
  // const [products, setProducts] = useState([]);
  // useEffect(() => {
  //   if (type.value !== '') {
  //     setProducts(list.filter(product => product.productType === type.value));
  //   } else {
  //     setProducts(list);
  //   }
  // }, [type, compCd]);

  const handleSelectProduct = (productInfo, hasChild) => {
    setSelectedProduct(prevState => {
      const productCode = productInfo?.productCode;
      const isSameProduct = checkSameProductCode(
        productInfo.productCode,
        prevState.code,
      );

      return {
        code: !isSameProduct
          ? productCode
          : prevState.childToggle
          ? ''
          : productCode,
        childToggle: !isSameProduct
          ? true
          : hasChild
          ? !prevState.childToggle
          : prevState.childToggle,
      };
    });

    setSelectedChild('');
  };

  // 상품선택
  const handleSelectChildProduct = product => {
    if (product.child) {
      const selectedChildProduct = product.child.find(item =>
        checkSameProductCode(item.productCode, selectedChild),
      );
      onSelectMainContract(selectedChildProduct);
    } else {
      onSelectMainContract(product);
    }
  };

  /**
   * 타입별 표시 상품 리스트 반환
   */
  const displayProducts = list
    .filter(product => type.value === '' || product.productType === type.value)
    .filter(res => {
      if (compCd !== PRODUCT_COMP_CD.cm) {
        return res.compCd === compCd;
      } else {
        return res;
      }
    });

  return (
    <>
      <ul className="insu-pro-list">
        {displayProducts.map((product, index) => {
          return (
            !SUB_PRD_CODE_SALES_STOP.includes(
              String(product.productCode).substring(0, 6),
            ) && (
              <Fragment key={index}>
                <Product
                  key={index}
                  product={product}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                  selectedChild={selectedChild}
                  setSelectedChild={setSelectedChild}
                  onSelectProduct={handleSelectProduct}
                  onSelectChildProduct={handleSelectChildProduct}
                  showModal={showModal}
                />
              </Fragment>
            )
          );
        })}
      </ul>
    </>
  );
};

/**
 * 주계약 상품 리스트
 * @param {object} props
 * @param {array} props.productList 전체 상품 리스트
 * @param {array} props.productTypeList 상품별 타입 리스트(종신, 연금/저축 등)
 * @param {boolean} props.checkSpecialCondition 특별조건부 체크박스 체크 여부
 * @param {array} props.policyConversion 종신 전환 가능 계약 건
 * @param {object} props.rePublishInfo 재발행 정보
 * @param {function} props.onSearchProduct 주계약 상품 조회
 * @param {function} props.onSelectMainContract 주계약 상품 선택
 * @param {function} props.onClose 주계약 상품 선택 팝업 닫기
 * @param {function} props.showModal 모달 팝업 호출
 * @returns {JSX.Element}
 * @constructor
 */
const MainContractList = props => {
  const {
    productList,
    productTypeList,
    checkSpecialCondition,
    policyConversion,
    usdProdYn = 'N',
    rePublishInfo,
    onSearchProduct,
    onSelectMainContract,
    onClose,
    showModal,
    searchRef,
    searchTextInput,
    setSearchTextInput,
    searchProduct,
  } = props;

  const [activeTab, setActiveTab] = useState('');
  const [products, setProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({
    code: '',
    childToggle: false,
  });
  const [selectedChild, setSelectedChild] = useState('');

  const [compCdSelect, setCompCheck] = useState(PRODUCT_COMP_CD.cm); //상품 선택
  const { channelInfo } = useSelector(state => state.userReducer);
  useEffect(() => {
    onSearchProduct();
  }, []);

  useEffect(() => {
    if (productTypeList.length > 0) {
      let list = productList;

      // if (checkSpecialCondition) {
      //   list = list
      //     .filter(
      //       item =>
      //         item.hasSpecialProduct === 'Y' ||
      //         (item.child &&
      //           item.child.find(child => child.hasSpecialProduct === 'Y')),
      //     )
      //     .map(item => {
      //       if (item.child) {
      //         return {
      //           ...item,
      //           child: item.child.filter(
      //             child => child.hasSpecialProduct === 'Y',
      //           ),
      //         };
      //       } else {
      //         return item;
      //       }
      //     });
      // }

      if (policyConversion.length > 0) {
        const isValidProduct = item => {
          return (
            item.isConvertableProduct === 'Y' &&
            (usdProdYn === 'N' || item.currencyUsdYN === 'Y')
          );
        };
        list = list
          .filter(
            item =>
              isValidProduct(item) ||
              (item.child && item.child.find(isValidProduct)),
          )
          .map(item => {
            if (item.child) {
              return {
                ...item,
                child: item.child.filter(isValidProduct),
              };
            } else {
              return item;
            }
          });
      }

      if (Object.keys(rePublishInfo).length > 0) {
        const { currencyUsdYN, isVariableProduct } = rePublishInfo;
        list = list.map(item => {
          let isDisabled = false;
          let disabledMsg = '';

          const itemUsdYN = item.child
            ? item.child[0].currencyUsdYN
            : item.currencyUsdYN;

          if (!isVariableProduct) {
            const isVariable = item.child
              ? item.child.find(c => c.isVariableProduct)
              : item.isVariableProduct;
            if (isVariable) {
              isDisabled = true;
              disabledMsg = ' 변액 상품으로 변경할 수 없어요.';
            } else {
              if (currencyUsdYN !== itemUsdYN) {
                isDisabled = true;
                disabledMsg = `${
                  currencyUsdYN === 'Y' ? '원화' : '달러'
                } 상품으로 변경할 수 없어요.`;
              }
            }
          } else {
            if (currencyUsdYN !== itemUsdYN) {
              isDisabled = true;
              disabledMsg = `${
                currencyUsdYN === 'Y' ? '원화' : '달러'
              } 상품으로 변경할 수 없어요.`;
            }
          }

          return { ...item, disabled: isDisabled, disabledMsg };
        });
      }
      setProducts(list);
      setProductTypes(
        productTypeList
          .map(product => {
            return {
              label: product.productTypeName,
              value: product.productType,
            };
          })
          .concat([{ label: '전체', value: '' }]),
      );
    }
  }, [productList, productTypeList, checkSpecialCondition, policyConversion]);

  useEffect(() => {
    setSelectedProduct({ code: '', childToggle: false });
    setSelectedChild('');
  }, [activeTab]);

  const selectCompProduct = cd => {
    setCompCheck(cd);
  };

  return (
    <>
      <header className="con-header">
        <div className="page-navi">
          <span onClick={onClose} className="btn-back">
            이전
          </span>
        </div>
        <h1 className="page-tit">{'주계약 상품 선택'}</h1>
      </header>
      <div className="con-wrap no-bottom">
        <div className="wide-con-wrap">
          {/* className: pop-box -> wide-con-wrap 변경*/}
          <div className="tbl-header">
            {/* [Robin]: KB/Pru 상품 선택 버튼 제거 */}
            {/* <div className="productChoiceBtn">
              <button
                type="button"
                className={`btn-s btn-a ${
                  compCdSelect === PRODUCT_COMP_CD.cm ? 'active' : ''
                }`}
                onClick={() => selectCompProduct(PRODUCT_COMP_CD.cm)}
              >
                KB라이프(전체)
              </button>
              <button
                type="button"
                className={`btn-s btn-k ${
                  compCdSelect === PRODUCT_COMP_CD.kb ? 'active' : ''
                }`}
                onClick={() => selectCompProduct(PRODUCT_COMP_CD.kb)}
              >
                구.KB생명
              </button>
              <button
                type="button"
                className={`btn-s btn-p ${
                  compCdSelect === PRODUCT_COMP_CD.pr ? 'active' : ''
                }`}
                onClick={() => selectCompProduct(PRODUCT_COMP_CD.pr)}
              >
                구.푸르덴셜
              </button>
            </div> */}

            <div className="right-area">
              <p className="text-info4 red">* 가입조건에 따라 가능한 상품이 보여집니다. (예:만나이,성별 등)</p>
              <div className="sch-box">
                <SatInput
                  ref={searchRef}
                  type={'search'}
                  value={searchTextInput}
                  placeholder={'상품명을 검색하세요'}
                  onChange={value => {
                    setSearchTextInput(value);
                  }}
                  onPressEnter={() => {
                    searchProduct(searchTextInput);
                    searchRef.current.onBlur();
                  }}
                />
              </div>
            </div>
          </div>
          <div className="tab-wrap">
            <SatTab
              activeTab={activeTab}
              onChange={setActiveTab}
              customStyleClass={'tab-nav tab-type2'}
            >
              {productTypes.map((productType, index) => {
                const recommendProductList = productList
                  .filter(res => res.isRecommendProduct === 'Y')
                  .sort(
                    (a, b) =>
                      a.isRecommendProductsortOrd - b.isRecommendProductsortOrd,
                  )
                  .map(res => ({ ...res, productType: '0' }));
                return (
                  <SatTab.TabPane key={index} tab={productType}>
                    {activeTab === '' ? (
                      <>
                        {productTypeList
                          //.filter(res => res.productType !== '0')
                          .map((res, index) => {
                            const result = products.filter(i => {
                              return i.productType === res.productType;
                            });

                            return (
                              <Fragment key={index}>
                                <p className="insu-pro-tit">
                                  {res.productTypeName}
                                </p>
                                <ProductList
                                  list={
                                    res.productType === '0'
                                      ? recommendProductList
                                      : $utils.checkGA(channelInfo.cdVal)
                                      ? result.filter(
                                          item =>
                                            item.isRecommendProduct !== 'Y',
                                        )
                                      : result
                                  }
                                  type={productType}
                                  selectedProduct={selectedProduct}
                                  setSelectedProduct={setSelectedProduct}
                                  selectedChild={selectedChild}
                                  setSelectedChild={setSelectedChild}
                                  onSelectMainContract={onSelectMainContract}
                                  showModal={showModal}
                                  compCd={compCdSelect}
                                />
                              </Fragment>
                            );
                          })}
                      </>
                    ) : activeTab === '0' ? (
                      <ProductList
                        list={recommendProductList}
                        type={productType}
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                        selectedChild={selectedChild}
                        setSelectedChild={setSelectedChild}
                        onSelectMainContract={onSelectMainContract}
                        showModal={showModal}
                        compCd={compCdSelect}
                      />
                    ) : (
                      <ProductList
                        list={products}
                        type={productType}
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                        selectedChild={selectedChild}
                        setSelectedChild={setSelectedChild}
                        onSelectMainContract={onSelectMainContract}
                        showModal={showModal}
                        compCd={compCdSelect}
                      />
                    )}
                  </SatTab.TabPane>
                );
              })}
            </SatTab>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContractList;
